import React, { useCallback, useState } from "react";
import { ButtonType } from "../shared/ButtonLink";
import {
  SectionContainer,
  SectionTitle,
  CardsContainer,
  Card,
  Title,
  Image,
  InputContainer,
  StyledInput,
  SmallButton,
  BigButton,
} from "./styles";
import { CardsSectionProps } from "../CardsSection/CardsSection";

export const CardsSection2 = (
  props: CardsSectionProps,
): JSX.Element | null => {
  if (!props?.isPublished) return null;

  const [inputValue, setInputValue] = useState<string>("");
  const handleChange = useCallback(
    (e) => {
      e.preventDefault();
      setInputValue(e.target.value);
    },
    [setInputValue],
  );

  return (
    <SectionContainer>
      <SectionTitle
        dangerouslySetInnerHTML={{
          __html: props.title,
        }}
      />
      <CardsContainer>
        {props.cards.map(
          (card) =>
            card.isPublished && (
              <Card key={card.title}>
                {card.title && <Title>{card.title}</Title>}
                <Image
                  src={card.image.src}
                  alt={card.image.alt}
                />
                {card.placeholder ? (
                  <InputContainer>
                    <StyledInput
                      label={card.placeholder}
                      value={inputValue}
                      onChange={handleChange}
                    />
                    <SmallButton
                      label={card.button.label}
                      link={
                        card.button.link +
                        `?zip=${inputValue}`
                      }
                      type={ButtonType.PRIMARY_LIGHT}
                    />
                  </InputContainer>
                ) : (
                  <BigButton
                    label={card.button.label}
                    link={card.button.link}
                    type={ButtonType.PRIMARY_LIGHT}
                  />
                )}
              </Card>
            ),
        )}
      </CardsContainer>
    </SectionContainer>
  );
};
